/*! customs-shader-material 2024-12-18 */

!function(e) {
    if ("object" == typeof exports && "undefined" != typeof module) module.exports = e(); else if ("function" == typeof define && define.amd) define([], e); else {
        ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).customsShaderMaterial = e();
    }
}(function() {
    return function s(i, o, u) {
        function c(t, e) {
            if (!o[t]) {
                if (!i[t]) {
                    var r = "function" == typeof require && require;
                    if (!e && r) return r(t, !0);
                    if (f) return f(t, !0);
                    var a = new Error("Cannot find module '" + t + "'");
                    throw a.code = "MODULE_NOT_FOUND", a;
                }
                var n = o[t] = {
                    exports: {}
                };
                i[t][0].call(n.exports, function(e) {
                    return c(i[t][1][e] || e);
                }, n, n.exports, s, i, o, u);
            }
            return o[t].exports;
        }
        for (var f = "function" == typeof require && require, e = 0; e < u.length; e++) c(u[e]);
        return c;
    }({
        1: [ function(r, e, t) {
            "use strict";
            e.exports = function e(t) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.opts = t, this.updateUVAttributes = r("./ComponentShadersUpdates/updateUVAttributes"), 
                this.copyVector2sArray = r("./ComponentShadersUpdates/copyVector2sArray");
            };
        }, {
            "./ComponentShadersUpdates/copyVector2sArray": 2,
            "./ComponentShadersUpdates/updateUVAttributes": 3
        } ],
        2: [ function(e, t, r) {
            "use strict";
            t.exports = function(e, t) {
                for (var r = 0, a = 0; a < t.length; ++a) {
                    var n = t[a];
                    void 0 === n && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", a), 
                    n = new Vector2()), e[r++] = n.x, e[r++] = n.y;
                }
                return e;
            };
        }, {} ],
        3: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var s = this, i = this.opts.THREE;
                try {
                    if (e instanceof i.Mesh && e.geometry instanceof i.Geometry) {
                        var o = new i.BufferGeometry().fromGeometry(e.geometry), u = e.geometry.faces;
                        e.geometry.faceVertexUvs && e.geometry.faceVertexUvs.forEach(function(e, t) {
                            var r = [];
                            if (0 < e.length) {
                                for (var a = 0; a < u.length; ++a) {
                                    var n = e[a];
                                    void 0 !== n ? r.push(n[0], n[1], n[2]) : r.push(new i.Vector2(), new i.Vector2(), new i.Vector2());
                                }
                                o.addAttribute("uv" + (0 == t ? "" : t + 1), new i.BufferAttribute(s.copyVector2sArray(new Float32Array(2 * r.length), r), 2));
                            }
                        }), e.geometry = o;
                    }
                    return e;
                } catch (e) {
                    throw log.error(e), e;
                }
            };
        }, {} ],
        4: [ function(r, e, t) {
            "use strict";
            e.exports = function e(t) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.opts = t, this.getBumpShaders = r("./FilteredShaders/getBumpShaders"), 
                this.getShadersByAttributes = r("./FilteredShaders/getShadersByAttributes"), this.getShadersForComponent = r("./FilteredShaders/getShadersForComponent"), 
                this.getStitchingShaders = r("./FilteredShaders/getStitchingShaders"), this.getSwatchShaders = r("./FilteredShaders/getSwatchShaders");
            };
        }, {
            "./FilteredShaders/getBumpShaders": 5,
            "./FilteredShaders/getShadersByAttributes": 6,
            "./FilteredShaders/getShadersForComponent": 7,
            "./FilteredShaders/getStitchingShaders": 8,
            "./FilteredShaders/getSwatchShaders": 9
        } ],
        5: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.shaders, r = e.attributes, a = {};
                return t && ((r = r || []).push("uv", "uv2"), a = this.getShadersByAttributes({
                    attributes: r,
                    shaders: t
                })), a;
            };
        }, {} ],
        6: [ function(e, t, r) {
            "use strict";
            var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            t.exports = function(e) {
                var s = e.shaders, i = e.attributes, o = {};
                return s && (i = i || [], [ "vertex", "fragment" ].forEach(function(e) {
                    if (s && s[e]) for (var t in o[e] = {}, s[e]) if ("object" === u(s[e][t])) {
                        var r = {}, a = !1;
                        for (var n in s[e][t]) 0 <= i.indexOf(n) && (r[n] = s[e][t][n], a = !0);
                        a && (o[e][t] = r);
                    } else o[e][t] = s[e][t];
                }), s.defines && (o.defines = s.defines)), o;
            };
        }, {} ],
        7: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.component, r = e.attributes, a = e.shaders, n = {};
                if (t && a) {
                    for (var s in r = r || [], t.geometry.attributes) r.push(s);
                    n = this.getShadersByAttributes({
                        attributes: r,
                        shaders: a
                    }), a.defines && (n.defines = a.defines);
                }
                return n;
            };
        }, {} ],
        8: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.shaders, r = e.attributes, a = {};
                return t && ((r = r || []).push("uv", "uv2"), a = this.getShadersByAttributes({
                    attributes: r,
                    shaders: t
                })), a;
            };
        }, {} ],
        9: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.shaders, r = e.attributes, a = {};
                return t && ((r = r || []).push("uv", "uv2", "uv3"), a = this.getShadersByAttributes({
                    attributes: r,
                    shaders: t
                })), a;
            };
        }, {} ],
        10: [ function(r, e, t) {
            "use strict";
            e.exports = function e(t) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.opts = t, this.consumeShaderChunks = r("./MaterialBuilderFactory/consumeShaderChunks"), 
                this.createMaterial = r("./MaterialBuilderFactory/createMaterial"), this.setUniform = r("./MaterialBuilderFactory/setUniform"), 
                this.updateMaterial = r("./MaterialBuilderFactory/updateMaterial");
            };
        }, {
            "./MaterialBuilderFactory/consumeShaderChunks": 11,
            "./MaterialBuilderFactory/createMaterial": 12,
            "./MaterialBuilderFactory/setUniform": 13,
            "./MaterialBuilderFactory/updateMaterial": 14
        } ],
        11: [ function(e, t, r) {
            "use strict";
            var d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            function p(e, t) {
                var r = "";
                switch (t) {
                  case "vec4":
                    r = "," + (4 <= e.length ? e[3] : 0) + r;

                  case "vec3":
                    r = "," + (3 <= e.length ? e[2] : 0) + r;

                  case "vec2":
                    r = "," + (2 <= e.length ? e[1] : 0) + r;

                  case "default":
                    r = "" + (1 <= e.length ? e[0] : 0) + r;
                }
                return r;
            }
            t.exports = function(e) {
                var t = e.material, s = e.shaders, r = e.uniforms, a = this.opts.THREE;
                if (s && t) {
                    var i = "";
                    if ([ "vertex", "fragment" ].forEach(function(e) {
                        var t = "";
                        if (s[e]) for (var r in s[e]) if ("object" === d(s[e][r])) {
                            var a = "";
                            for (var n in s[e][r]) a += s[e][r][n].replace(/\n/g, "\\n").replace(/\'/g, "\\'");
                            t += ".replace('#include <" + r + ">', '" + a + "')";
                        } else t += ".replace('#include <" + r + ">', '" + s[e][r].replace(/\n/g, "\\n").replace(/\'/g, "\\'") + "')";
                        i += "shader." + e + "Shader = shader." + e + "Shader" + t + ";\n";
                    }), s.defines) for (var n in s.defines) {
                        var o = new RegExp("\\${" + n + "}", "g"), u = t[n], c = s.defines[n].type, f = c + "(" + p(s.defines[n].default.split(","), c) + ")";
                        f = u instanceof a.Color ? c + "(" + p([ u.r, u.g, u.b ], c) + ")" : u instanceof a.Vector2 || u instanceof a.Vector3 || u instanceof a.Vector4 ? c + "(" + p(u.toArray(), c) + ")" : "number" == typeof u ? "" + u : "float" == c ? "" + p(s.defines[n].default.split(","), c) : c + "(" + p(s.defines[n].default.split(","), c) + ")", 
                        i = i.replace(o, f);
                    }
                    for (var l in r = r || {}) {
                        var h = "";
                        switch (r[l].type) {
                          case "i":
                            h = "int ${name}";
                            break;

                          case "f":
                            h = "float ${name}";
                            break;

                          case "v2":
                            h = "vec2 ${name}";
                            break;

                          case "v3":
                            h = "vec3 ${name}";
                            break;

                          case "v4":
                            h = "vec4 ${name}";
                            break;

                          case "c":
                            h = "vec3 ${name}";
                            break;

                          case "m4":
                            h = "mat4 ${name}";
                            break;

                          case "t":
                            h = "sampler2D ${name}";
                            break;

                          case "t3":
                            h = "sampler2DCube ${name}";
                            break;

                          case "iv1":
                            h = "int ${name}[${size}]";
                            break;

                          case "iv":
                            h = "ivec3 ${name}[${size}]";
                            break;

                          case "fv1":
                            h = "float ${name}[${size}]";
                            break;

                          case "fv":
                            h = "vec3 ${name}[${size}]";
                            break;

                          case "v2v":
                            h = "vec2 ${name}[${size}]";
                            break;

                          case "v3v":
                            h = "vec3 ${name}[${size}]";
                            break;

                          case "v4v":
                            h = "vec4 ${name}[${size}]";
                            break;

                          case "m4v":
                            h = "mat4 ${name}[${size}]";
                            break;

                          case "tv":
                            h = "sampler2D ${name}[${size}]";
                        }
                        i += 'shader.vertexShader = "uniform ' + h.replace("${name}", l).replace("${size}", r[l].size) + ';\\n" + shader.vertexShader;\n', 
                        i += 'shader.fragmentShader = "uniform ' + h.replace("${name}", l).replace("${size}", r[l].size) + ';\\n" + shader.fragmentShader;\n';
                    }
                    i += "this.shader = shader;\n", i += 'if (typeof this.uniforms === "object" && this.uniforms !== null) {\n', 
                    i += "  for (let uniform in this.uniforms) {\n", i += "    this.shader.uniforms[uniform] = {type:this.uniforms[uniform].type, value:this.uniforms[uniform].value};\n", 
                    i += "  }\n", i += "}\n", t.uniforms = r, t.onBeforeCompile = new Function("shader", i);
                }
                return t;
            };
        }, {} ],
        12: [ function(e, t, r) {
            "use strict";
            var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            t.exports = function(e) {
                var t = e.meshType, r = e.options, a = e.shaders, n = e.uniforms;
                r = r || {};
                var s = new this.opts.THREE[t](r);
                return this.updateMaterial({
                    material: s,
                    options: r,
                    uniforms: n
                }), (a = a && "object" === (void 0 === a ? "undefined" : i(a)) ? a : r.shaders) && this.consumeShaderChunks({
                    shaders: a,
                    material: s,
                    uniforms: n
                }), s;
            };
        }, {} ],
        13: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.material, r = e.uniformName, a = e.value;
                return !!t && (t.uniforms[r].value = a, t.shader && t.shader.uniforms[r] && (t.shader.uniforms[r].value = a), 
                !0);
            };
        }, {} ],
        14: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = e.material, r = e.options, a = (e.uniforms, this.opts.THREE);
                if (t && r) {
                    var n = new a.TextureLoader();
                    [ "bumpScale", "metalness", "opacity", "reflectivity", "roughness", "shininess", "transparent" ].forEach(function(e) {
                        r[e] && void 0 !== r[e] && (t[e] = r[e]);
                    });
                    [ "map", "alphaMap", "aoMap", "bumpMap", "lightMap", "normalMap", "roughnessMap", "specularMap" ].forEach(function(e) {
                        r[e] && void 0 !== r[e] && (t[e] = "string" == typeof r[e] ? n.load(r[e]) : r[e]);
                    });
                    [ "color", "emissive", "specular" ].forEach(function(e) {
                        r[e] && void 0 !== r[e] && (t[e] = "string" == typeof r[e] ? new a.Color(r[e]) : r[e]);
                    }), r.blending && void 0 !== r.blending && (t.blending = "string" == typeof r.blending ? a[r.blending] : r.blending), 
                    r.normalScale && void 0 !== r.normalScale && (t.normalScale = t.normalScale instanceof Array ? new a.Vector2(r.normalScale[0], r.normalScale[1]) : t.normalScale);
                }
                return t;
            };
        }, {} ],
        15: [ function(r, e, t) {
            "use strict";
            e.exports = function e(t) {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.opts = t, this.hasBumpUV = r("./MaterialHelpers/hasBumpUV"), this.hasSwatchUV = r("./MaterialHelpers/hasSwatchUV"), 
                this.loadShaders = r("./MaterialHelpers/loadShaders"), this.buildShaders = r("./MaterialHelpers/buildShaders");
            };
        }, {
            "./MaterialHelpers/buildShaders": 16,
            "./MaterialHelpers/hasBumpUV": 17,
            "./MaterialHelpers/hasSwatchUV": 18,
            "./MaterialHelpers/loadShaders": 19
        } ],
        16: [ function(e, t, r) {
            "use strict";
            var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            t.exports = function(e) {
                try {
                    var a = "string" == typeof e ? JSON.parse(e) : e;
                    return [ "vertex", "fragment" ].forEach(function(e) {
                        if (a[e]) for (var t in a[e]) if (a[e][t] instanceof Array) a[e][t] = a[e][t].join(""); else if ("object" === n(a[e][t])) for (var r in a[e][t]) a[e][t][r] instanceof Array && (a[e][t][r] = a[e][t][r].join(""));
                    }), a;
                } catch (e) {
                    throw e;
                }
            };
        }, {} ],
        17: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = !1;
                if (e) if (e.geometry.isGeometry) console.warn("BufferGeometry was not found. Please call MaterialBuilder.MaterialHelpers.updateUVAttributes()."); else for (var r in e.geometry.attributes) if ("uv2" === r) {
                    t = !0;
                    break;
                }
                return t;
            };
        }, {} ],
        18: [ function(e, t, r) {
            "use strict";
            t.exports = function(e) {
                var t = !1;
                if (e) if (e.geometry.isGeometry) console.warn("BufferGeometry was not found. Please call MaterialBuilder.MaterialHelpers.updateUVAttributes()."); else for (var r in e.geometry.attributes) if ("uv3" === r) {
                    t = !0;
                    break;
                }
                return t;
            };
        }, {} ],
        19: [ function(c, e, t) {
            "use strict";
            e.exports = function(e, n) {
                var s = this, t = e.url, r = e.path, a = e.json;
                if ("string" == typeof t) (0, this.opts.request)({
                    url: t,
                    method: "GET",
                    json: !0
                }, function(e, t, r) {
                    if (e) return n(e);
                    if (200 !== t.statusCode) return n({
                        status: t.statusCode,
                        message: t.statusMessage
                    });
                    var a = {};
                    return r && (a = s.buildShaders(r)), n(null, a);
                }); else if ("string" == typeof r) {
                    var i = c(r);
                    try {
                        var o = this.buildShaders(i);
                        return n(null, o);
                    } catch (e) {
                        return n(e);
                    }
                } else if (a) try {
                    var u = this.buildShaders(a);
                    return n(null, u);
                } catch (e) {
                    return n(e);
                }
            };
        }, {} ],
        20: [ function(e, t, r) {
            "use strict";
            var a = e("./MaterialBuilderFactory"), n = e("./FilteredShaders"), s = e("./ComponentShadersUpdates"), i = e("./MaterialHelpers");
            t.exports = function e(t) {
                var r = this;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.opts = t || {}, this.shaders = {}, this.getShaders = function() {
                    return r.shaders;
                }, this.setShaders = function(e) {
                    r.shaders = e;
                }, this.MaterialBuilderFactory = new a(this.opts), this.FilteredShaders = new n(this.opts), 
                this.ComponentShadersUpdates = new s(this.opts), this.MaterialHelpers = new i(this.opts);
            };
        }, {
            "./ComponentShadersUpdates": 1,
            "./FilteredShaders": 4,
            "./MaterialBuilderFactory": 10,
            "./MaterialHelpers": 15
        } ]
    }, {}, [ 20 ])(20);
});